export default class ProductVariantSelector {
  constructor() {
    this.variantsElement = document.querySelector("#variant-selection")
    this.variantsPrice = document.querySelector(".product-price")

    if (!this.variantsElement) return

    this.variants = this.variantsElement.querySelectorAll(".product-variant-label")

    for (let variant of this.variants) {
      let disabled = variant.getAttribute("disabled")

      if (!disabled) {
        variant.addEventListener("click", this.handleClickVariant.bind(this))
      }
    }
  }

  triggerVariantSelected(imageId) {
    const variantSelectedEvent = new CustomEvent("variantSelected", { detail: imageId })

    document.dispatchEvent(variantSelectedEvent)
  }

  updateVariantPricing(variantPrice) {
    this.variantsPrice.innerText = variantPrice
  }

  handleClickVariant(event) {
    const imageId = event.target.dataset.imageId
    const selectedVariantPrice = event.target.dataset.productPrice

    this.triggerVariantSelected(imageId)

    if (selectedVariantPrice.length) {
      this.updateVariantPricing(selectedVariantPrice)
    }
  }
}
